import { render, staticRenderFns } from "./FaxSendStatusSelect.vue?vue&type=template&id=2d50b69f&lang=pug"
import script from "./FaxSendStatusSelect.vue?vue&type=script&lang=js"
export * from "./FaxSendStatusSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports